import { render } from "./ListVehicles.vue?vue&type=template&id=820b52c0&scoped=true&ts=true"
import script from "./ListVehicles.vue?vue&type=script&lang=ts"
export * from "./ListVehicles.vue?vue&type=script&lang=ts"

import "./ListVehicles.vue?vue&type=style&index=0&id=820b52c0&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820b52c0"]])

export default __exports__